import { Injectable, inject } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

import { environment } from '@env/environment';

declare global {
  // interface Window {
  //   SN_CSM_EC?: {
  //     onLogin?: () => void;
  //     onLogout?: () => void;
  //   };
  //   getOktaIdToken?: () => string | undefined;
  // }

  interface Window {
    SN_CSM_EC?: {
      init?: (config: any) => void;
      loadEMFeature?: () => any;
      onLogin?: () => void;
      onLogout?: () => void;
      passContext?: (context: { clientName: string; sysparm_skip_load_history: boolean }) => void;
    };
    getOktaIdToken?: () => string | undefined;
    initServiceNowEngagementMessenger?: (moduleId: string) => void;
  }
}

// Bridges Okta auth state to the ServiceNow Engagement Messenger widget loaded in index.html.
@Injectable({ providedIn: 'root' })
export class EngagementMessengerService {
  private readonly oktaAuth = inject(OKTA_AUTH) as OktaAuth;
  private hasNotifiedLogin = false;

  constructor() {
    console.log('[EM] Registering Angular Okta token bridge');
    window.getOktaIdToken = () => {
      const idToken = this.oktaAuth.getIdToken();
      console.log('[EM] ID token available:', !!idToken);
      this.inspectJwt(idToken);
      return idToken;
    };
  }

  private inspectJwt(idToken: string | undefined): void {
    if (!idToken) {
      console.log('No ID token');
      return;
    }

    const payload = JSON.parse(atob(idToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));

    console.log('[EM] token claims::', {
      iss: payload.iss,
      aud: payload.aud,
      sub: payload.sub,
      email: payload.email,
      preferred_username: payload.preferred_username,
      name: payload.name,
      exp: payload.exp,
    });
  }

  notifyLogin(): void {
    console.log('[EM] notifyLogin called');
    if (this.hasNotifiedLogin) {
      console.log('[EM] notifyLogin skipped: login was already notified');
      return;
    }

    const idToken = this.oktaAuth.getIdToken();

    console.log('[EM] ---------------------- notifyLogin', {
      hasIdToken: !!idToken,
      messengerAvailable: typeof window.SN_CSM_EC?.onLogin === 'function',
    });

    if (!idToken) {
      console.error('[EM] Cannot call onLogin: ID token is not available');
      return;
    }

    if (typeof window.SN_CSM_EC?.onLogin === 'function') {
      console.log('[EM] Calling SN_CSM_EC.onLogin');
      try {
        window.SN_CSM_EC.onLogin();
        this.hasNotifiedLogin = true;
        console.log('[EM] SN_CSM_EC.onLogin completed');

        if (typeof window.SN_CSM_EC?.passContext === 'function') {
          window.SN_CSM_EC.passContext({
            clientName: environment.engagementMessenger.clientName,
            sysparm_skip_load_history: true,
          });
          console.log('[EM] SN_CSM_EC.passContext called');
        }
      } catch (error) {
        console.error('[EM] SN_CSM_EC.onLogin failed', error);
      }
      return;
    }

    console.error('[EM] Cannot call onLogin: SN_CSM_EC.onLogin is unavailable');
  }

  notifyLogout(): void {
    console.log('[EM] notifyLogout called');
    if (typeof window.SN_CSM_EC?.onLogout === 'function') {
      console.log('[EM] Calling SN_CSM_EC.onLogout');
      try {
        window.SN_CSM_EC.onLogout();
        console.log('[EM] SN_CSM_EC.onLogout completed');
      } catch (error) {
        console.error('[EM] SN_CSM_EC.onLogout failed', error);
      }
    } else {
      console.error('[EM] Cannot call onLogout: SN_CSM_EC.onLogout is unavailable');
    }

    this.hasNotifiedLogin = false;
  }
}
